import ExtraInfoSection from './styled';

export default ExtraInfoSection;
